// Production build config for the .org estate — same merge pattern as
// config.prod.js (see config.js for why authConfig must be baked at build time).
// CI (.github/workflows/stac-browser.yml, target "org") swaps this file in as
// config.js before building, then syncs dist/ to the efa-org-stac-browser bucket.
//
// Served from stac.firesat.org (CloudFront, aek/tofu/10-platform/stac-browser.tf);
// talks cross-origin to the geoapi gateway at api.firesat.org and logs in against
// the .org Keycloak with the public client `stac-browser`
// (aek/tofu/30-keycloak/clients-stac.tf). Runbook: aek/geoapi/README.md.
const base = require("./config.default.js");

module.exports = Object.assign({}, base, {
  catalogUrl: "https://api.firesat.org/stac",
  catalogTitle: "FireSat STAC",
  catalogImage: "/branding/firesat-lockup-horizontal.svg",
  historyMode: "history",

  // Domains the Keycloak bearer token may be attached to: ONLY the STAC API.
  // Thumbnails (same origin, /thumbnails/*) must NOT be listed, or the token
  // leaks into requests that do not need it.
  allowedDomains: ["api.firesat.org"],

  // As in config.prod.js: band COGs are not rendered client-side (geotiff.js
  // fetches without the token and would 401); the thumbnail is the preview.
  displayOverview: false,

  authConfig: {
    type: "openIdConnect",
    openIdConnectUrl:
      "https://auth.firesat.org/realms/efa/.well-known/openid-configuration",
    oidcConfig: {
      client_id: "stac-browser",
    },
  },
});
